export const FieldTypes = {
  ACTION: 'action'
};
export const NameTypes = {
  ACTION: 'Action'
};